class GadaInvoiceRequest extends HTMLElement {
  connectedCallback() {
    if (this.isBound) return;

    this.isBound = true;
    this.dataset.ready = 'true';
    this.toggle = this.querySelector('[data-invoice-toggle]');
    this.fields = this.querySelector('[data-invoice-fields]');
    this.requestValue = this.querySelector('[data-invoice-request-value]');
    this.vat = this.querySelector('[data-invoice-vat]');
    this.sdi = this.querySelector('[data-invoice-sdi]');
    this.pec = this.querySelector('[data-invoice-pec]');
    this.error = this.querySelector('[data-invoice-error]');
    this.scope = this.closest('cart-drawer-component') || this.closest('.cart-page') || document;
    this.form = this.scope.querySelector('#cart-form') || document.getElementById('cart-form');

    this.handleToggle = () => {
      window.clearTimeout(this.saveTimer);
      this.syncState(true);
      this.save();
    };
    this.handleInput = () => {
      this.clearValidation();
      window.clearTimeout(this.saveTimer);
      this.saveTimer = window.setTimeout(() => this.save(), 400);
    };
    this.handleChange = () => {
      window.clearTimeout(this.saveTimer);
      this.save();
    };
    this.handleSubmit = event => {
      if (this.validate()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    };
    this.handleCheckout = event => {
      const button = event
        .composedPath()
        .find(node => node instanceof Element && node.matches('button[name="checkout"]'));
      if (!button || (this.scope !== document && !this.scope.contains(button))) return;
      this.handleSubmit(event);
    };

    this.toggle.addEventListener('change', this.handleToggle);
    [this.vat, this.sdi, this.pec].forEach(input => {
      input.addEventListener('input', this.handleInput);
      input.addEventListener('change', this.handleChange);
    });
    this.form?.addEventListener('submit', this.handleSubmit, true);
    document.addEventListener('click', this.handleCheckout, true);
    this.syncState(!this.toggle.checked);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('change', this.handleToggle);
    [this.vat, this.sdi, this.pec].forEach(input => {
      input?.removeEventListener('input', this.handleInput);
      input?.removeEventListener('change', this.handleChange);
    });
    this.form?.removeEventListener('submit', this.handleSubmit, true);
    document.removeEventListener('click', this.handleCheckout, true);
    window.clearTimeout(this.saveTimer);
    this.isBound = false;
    delete this.dataset.ready;
  }

  syncState(clearValues) {
    const requested = this.toggle.checked;
    this.toggle.setAttribute('aria-expanded', String(requested));
    this.fields.hidden = !requested;
    this.requestValue.value = requested ? 'Sì' : '';
    this.vat.required = requested;

    if (!requested && clearValues) {
      this.vat.value = '';
      this.sdi.value = '';
      this.pec.value = '';
    }

    this.clearValidation();
  }

  clearValidation() {
    [this.vat, this.sdi, this.pec].forEach(input => {
      input.setCustomValidity('');
      input.removeAttribute('aria-invalid');
    });
    this.hideError();
  }

  hideError() {
    this.error.hidden = true;
    this.error.textContent = '';
  }

  validate() {
    this.clearValidation();
    if (!this.toggle.checked) return true;

    if (!this.vat.value.trim()) {
      this.vat.setCustomValidity(this.dataset.errorRequired);
    }

    if (!this.sdi.value.trim() && !this.pec.value.trim()) {
      this.sdi.setCustomValidity(this.dataset.errorRecipient);
    }

    if (this.pec.value.trim() && this.pec.validity.typeMismatch) {
      this.pec.setCustomValidity(this.dataset.errorPec);
    }

    const invalid = [this.vat, this.sdi, this.pec].find(input => !input.checkValidity());
    if (!invalid) return true;

    invalid.setAttribute('aria-invalid', 'true');
    this.error.textContent = invalid.validationMessage;
    this.error.hidden = false;
    invalid.focus();
    invalid.reportValidity();
    return false;
  }

  attributes() {
    if (!this.toggle.checked) {
      return {
        'Richiesta fattura': '',
        'Partita IVA': '',
        'Codice SDI': '',
        PEC: ''
      };
    }

    return {
      'Richiesta fattura': 'Sì',
      'Partita IVA': this.vat.value.trim(),
      'Codice SDI': this.sdi.value.trim().toUpperCase(),
      PEC: this.pec.value.trim()
    };
  }

  async save() {
    this.setAttribute('aria-busy', 'true');
    const root = window.Shopify?.routes?.root || '/';

    try {
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ attributes: this.attributes() })
      });

      if (!response.ok) throw new Error('save_failed');
    } catch {
      this.error.textContent = this.dataset.saveError;
      this.error.hidden = false;
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('gada-invoice-request')) {
  customElements.define('gada-invoice-request', GadaInvoiceRequest);
}
